<div *ngIf="searchId==0" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearchX0" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearchX0">
  </datalist>
</div>
<div *ngIf="searchId==1" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearchX1" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearchX1">
  </datalist>
</div>
<div *ngIf="searchId==2" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearchX2" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearchX2">
  </datalist>
</div>
<div *ngIf="searchId==3" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearchX3" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearchX3">
  </datalist>
</div>
<div *ngIf="searchId==4" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearchX4" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearchX4">
  </datalist>
</div>
<div *ngIf="searchId==5" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearchX5" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearchX5">
  </datalist>
</div>
<div *ngIf="searchId==6" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearchX6" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearchX6">
  </datalist>
</div>
<div *ngIf="searchId==7" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearchX7" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearchX7">
  </datalist>
</div>
<div *ngIf="searchId==8" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearchX8" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearchX8">
  </datalist>
</div>
<div *ngIf="searchId==9" class="search-group">
  <input [(ngModel)]="geoSearch" type='text' placeholder="{{translate('Buscar')}}..." autocorrect="off"
    autocapitalize="off" spellcheck="off" list="hereMapSearchX9" (ngModelChange)="onChangeSearch($event)"
    (change)="onSelectSearch($event)" />
  <datalist id="hereMapSearchX9">
  </datalist>
</div>